export class GetLeagueSelectorButtonTextHelper {
  //
  static getLeagueSelectorButtonText(props: Record<string, any>): string {
    const leagues = props.intl.formatMessage({
      id: "global-events-navigation-leagues",
    });
    const numberSelected = props.filteredCompetitionCount;
    return props.unfilteredCompetitionCount
      ? `${numberSelected}/${props.unfilteredCompetitionCount} ${leagues}`
      : `0 ${leagues}`;
  }
}
